
import { FC, useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import AsyncSelect from 'react-select/async';
import {OptionsOrGroups} from 'react-select'
import { Field, Form, Formik, FormikErrors, FormikHelpers, FormikProps } from 'formik';
import * as Yup from "yup";
import FormErrorContainer from '../../../sections/shared/FormErrorContainer';
import { CircularProgress } from '@mui/material';
import { TemplateStep2FormValidation } from '../../../../utiles/formValidation';
import useUtils from "../../../../utiles/useUtiles";

interface SelectType {
	label: string, 
	value: string
}
interface HeaderStructureFormErrors {
	headerType: string, 
	rowNumber: string, 
	columnNumber: string, 
	csvTypeId: SelectType,
	networkId: SelectType, 
	templateName: string
}
interface Props {
    setStep: ( n: number ) => void, 
    csvUUID: string | null
}
const HeaderStructure: React.FC<Props> = ( { setStep, csvUUID } ): JSX.Element => {

	// const [csvTypes, setCsvTypes] = useState({count: 0, rows: []});
	const [templateType, setTemplateType] = useState<any | null>( null );
	const [networkList, setNetworkList] = useState<any[]>( [] );
	const [csvDetails, setCsvDetails] = useState<any>( null );
	const [loading, setLoading] = useState<boolean>( false );
	const formikRef = useRef<any>(null);

	const { axiosRequest, baseUrl, toastInstance } = useUtils()
    const axios = axiosRequest();
    const toast = toastInstance();

	useEffect( () => {
		// fetchCsvTypes();
		fetchCsvDetails();
	}, [] );

	useEffect( () => {
        if ( templateType ) {
            fetchNetwork( '', templateType['value'] );
        }
    }, [ templateType ] );

	const csvTypeOptions = ( inputValue: string ): Promise<any[]> => {
		return new Promise<any[]>( async ( resolve ) => {
			const result = await fetchCsvTypes( inputValue );
			resolve( result );
		});
	}
    
	const fetchCsvTypes = ( searchText: string ): Promise<any[]> => {
        return new Promise<any[]>( async ( resolve ) => {
            const request = await axios.get( `${baseUrl()}/template_types?page=0&pageSize=5&searchText=${searchText}` );
            const { error, result, message } = request.data;

            if ( error ) {
                toast.error( message );
                resolve( [] );
            } else {
                const data = result['rows'].map( (r: any) => ( {
                    label: r.name,
                    value: r.id 
                } ) );
                resolve( data );
            }
        } );
	};

	const networkOptions = ( inputValue: string ): Promise<any[]> => {
		return new Promise<any[]>( async ( resolve ) => {
			if ( templateType && templateType['value'] ) {
				const result: any[] = await fetchNetwork( inputValue, templateType && templateType['value'] );
				resolve(result);
			} else {
				resolve([]);
			}
		});
	}
	const fetchNetwork = ( searchText: string, templateType: string ): Promise<any[]> => {
        return new Promise<any[]>( async ( resolve ) => {
			var query = '';
            if ( searchText ) {
                query += `&searchText=${searchText}`;
            } if ( templateType ) {
                query += `&csvTypeId=${templateType}`;
            }
            const request = await axios.get( `${baseUrl()}/template_type_networks?page=0&pageSize=5${query}` );
            const { error, result, message } = request.data;

            if ( error ) {
                toast.error( message );
				setNetworkList([]);
                resolve( [] );
            } else {
                const data = result['rows'].map((r: any) => ( {
                    label: r.name,
                    value: r.id 
                } ) );
				setNetworkList( data );
                resolve( data );
            }
        } );
	};
	const onChangeNetwork = ( searchText: string ) => {
		if ( templateType && templateType['value'] ) {
			fetchNetwork(searchText, templateType['value']);
		}
	}
	const fetchCsvDetails = async () => {
		setLoading( true );
			const request = await axios.get( `${baseUrl()}/template/uploaded/csv-details/${csvUUID}` );
		const { error, result, message } = request.data;
		setLoading( false );

		if ( error ) {
			toast.error( message );
		} else {
			setCsvDetails( result );
		}
	};
	const handleFormSubmit = async ( values: any ) => {
		setLoading( true );
		const params = {
			...values,
			csvTypeId: +values['csvTypeId']['value'],
			networkId: values['networkId'] ? +values['networkId']['value'] : null
		};
		const request = await axios.put( `${baseUrl()}/template/upload/csv/${csvUUID}`, params );
        const { error, result, message } = request.data;
		setLoading( false );

		if ( error ) {
			toast.error( message );
		} else {
			toast.success( message );
			setStep( 3 );
		}
	};
	return (
		<div className="main-card">
			<Formik
				innerRef={formikRef}
				initialValues={{
					headerType: 'horizontal', 
					rowNumber: 1, 
					columnNumber: 1, 
					csvTypeId: '',
					networkId: null, 
					templateName: ''
				} as any}
				validateOnChange={true}
				validateOnBlur={true}
				validationSchema={TemplateStep2FormValidation}
				onSubmit={async ( values, helpers ) => {
					handleFormSubmit( values );
				}}>
				{( { errors, values, handleChange, getFieldProps }: {errors: FormikErrors<HeaderStructureFormErrors>, values: any, handleChange: any, getFieldProps: any} ) => (
					<Form>
						<h1 className="text-center mb-5">Define Header Structure</h1>
						{
							csvDetails && csvDetails.csv && csvDetails.csv.data && csvDetails.csv.data.length && (
								<div className="mb-4 bootstrap-table-size">
									<h4 className="mb-2">Uploaded CSV</h4>
									<Table responsive striped bordered size="sm" className="snapshot-table">
										<tbody>
											{
												csvDetails.csv.data.map( ( data: any, index: number ) => (
													<tr key={index}>
														{
															Object.keys( data ).map( ( column: string, columnIndex: number ) => (
																<td className="text-center" key={columnIndex}>
																	{ data[column] }
																</td>
															) )
														}
													</tr>
												))
											}
										</tbody>
									</Table>
								</div>
							) || ''
						}
						
						<h4 className="mb-2">Select Header Type</h4>
						<div className="row col-md-12">
							<div className="d-flex gap-4 mb-5">
								<div className="form-check mr-4">
									<input
										{ ...getFieldProps( 'headerType' ) }
										className="form-check-input"
										type="radio"
										name="headerType"
										id="horizontal_headerType"
										value={'horizontal'}
										defaultChecked={values.headerType === 'horizontal'}
									/>
									<label className="form-check-label"  htmlFor="horizontal_headerType">
										Horizontal
									</label>
								</div>
								<div className="form-check mr-4">
									<input
										{ ...getFieldProps( 'headerType' ) }
										className="form-check-input"
										type="radio"
										name="headerType"
										id="vertical_headerType"
										value={'vertical'}
										defaultChecked={values.headerType === 'vertical'}
									/>
									<label className="form-check-label" htmlFor="vertical_headerType">
										Vertical
									</label>
								</div>
								<div className="form-check">
									<input
										{ ...getFieldProps( 'headerType' ) }
										className="form-check-input"
										type="radio"
										name="headerType"
										id="noHeaders_headerType"
										value={'noHeaders'}
										defaultChecked={values.headerType === 'noHeaders'}
									/>
									<label className="form-check-label" htmlFor="noHeaders_headerType">
										No Headers
									</label>
								</div>
								<FormErrorContainer nameError={errors.headerType}  />
							</div>
						</div>
						<div className="row mb-4">
							<div className="col-md-6">
								<h4 className="mb-2">Header Row Starting Cell<span className='text-danger'>*</span></h4>
								<input data-cy="inputHeaderRowStartingCell" type={"number"} className="form-control" placeholder="Row Position" { ...getFieldProps( 'rowNumber' ) } />
								<FormErrorContainer nameError={errors.rowNumber}  />
							</div>
							<div className="col-md-6">
								<h4 className="mb-2">Header Column Starting Cell<span className='text-danger'>*</span></h4>
								<input type={"number"} placeholder="Row Position" { ...getFieldProps( 'columnNumber' ) } className="form-control" />
								<FormErrorContainer nameError={errors.columnNumber}  />
							</div>
						</div>
						<div className="row mb-4">
							<div className="col-md-6">
								<h4 className="mb-2">Select Template Types<span className='text-danger'>*</span></h4>
								<AsyncSelect 
									data-cy="selectTemplateType"
                                    cacheOptions 
                                    loadOptions={csvTypeOptions} 
                                    defaultOptions 
                                    name="csvTypeId" 
                                    value={values.csvTypeId}
                                    onChange={selectedOption => {
                                        let event = { target: { name: 'csvTypeId', value: selectedOption } };
										handleChange({ target: 
											{ 
												name: 'networkId', 
												value: null
											} 
										});
										handleChange( event );
										setTemplateType( selectedOption );
										setNetworkList([]);
                                    }} 
                                />
								
								<FormErrorContainer nameError={errors.csvTypeId?.value} />
								
							</div>
							<div className="col-md-6">
								<h4 className="mb-2">Select Network</h4>
								<AsyncSelect 
									data-cy="selectNetwork"
                                    loadOptions={networkOptions} 
                                    defaultOptions={networkList}
									onInputChange={onChangeNetwork}
                                    name="networkId" 
                                    value={values.networkId}
                                    onChange={selectedOption => {
                                        let event = { target: { name: 'networkId', value: selectedOption } };
                                        handleChange( event );
                                    }} 
                                />
								<FormErrorContainer nameError={errors.networkId?.value} />
							</div>
						</div>
						<div className="row mb-4">
							<div className="col-md-6">
								<h4 className="mb-2">Template Name<span className='text-danger'>*</span></h4>
								<input data-cy="inputTemplateName" type={"text"} placeholder="Template Name" { ...getFieldProps( 'templateName' ) } className="form-control" />
								<FormErrorContainer nameError={errors.templateName} />
							</div>
						</div>
						
						<div>
							<button data-cy="btnSubmit" type="submit" className="btn btn-md revrex-primary-btn mt-3" disabled={loading}>
								<span>{ loading && ( <CircularProgress size={20} color={'success'} /> ) || 'Submit' }</span>
							</button>
						</div>
					</Form>
				)}
			</Formik>
		</div>
	);
}

export default HeaderStructure